import React from 'react';
import { 
  FaBullhorn, FaVideo, FaChalkboardTeacher, FaRocket, 
  FaCalendarCheck, FaClock, FaLink 
} from 'react-icons/fa';

const AnnouncementCard = ({ announcement }) => {
  const typeConfig = {
    training: { icon: FaChalkboardTeacher, color: 'blue', label: 'Live Training' },
    webinar: { icon: FaVideo, color: 'purple', label: 'Webinar' },
    seminar: { icon: FaChalkboardTeacher, color: 'green', label: 'Seminar' },
    service_launch: { icon: FaRocket, color: 'orange', label: 'New Service' },
    general: { icon: FaBullhorn, color: 'yellow', label: 'Update' }
  };

  const config = typeConfig[announcement.announcement_type] || typeConfig.general;
  const Icon = config.icon;
  
  const colorClasses = {
    blue: 'text-blue-400 bg-blue-500/20 border-blue-500/50',
    purple: 'text-purple-400 bg-purple-500/20 border-purple-500/50',
    green: 'text-green-400 bg-green-500/20 border-green-500/50',
    orange: 'text-orange-400 bg-orange-500/20 border-orange-500/50',
    yellow: 'text-[#FFD700] bg-[#FFD700]/20 border-[#FFD700]/50'
  };

  const priorityStyles = {
    high: 'border-l-4 border-l-red-500',
    normal: '',
    low: 'opacity-80'
  };

  return (
    <div className={`bg-[#0F172A] rounded-lg p-4 border border-[#2D5A8F] ${priorityStyles[announcement.priority] || ''}`}>
      <div className="flex items-start space-x-3">
        <div className={`w-10 h-10 rounded-lg ${colorClasses[config.color]} flex items-center justify-center flex-shrink-0`}>
          <Icon size={18} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-2 mb-1">
            <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${colorClasses[config.color]}`}>
              {config.label}
            </span>
            {announcement.priority === 'high' && (
              <span className="px-2 py-0.5 bg-red-500/20 text-red-400 rounded-full text-xs font-medium">
                Important
              </span>
            )}
          </div>
          <h4 className="text-white font-bold text-sm mb-1">{announcement.title}</h4>
          <p className="text-gray-400 text-sm mb-2">{announcement.description}</p>
          
          {/* Event Details */}
          {(announcement.event_date || announcement.event_time) && (
            <div className="flex items-center space-x-4 text-xs text-gray-400 mb-2">
              {announcement.event_date && (
                <span className="flex items-center space-x-1">
                  <FaCalendarCheck size={12} />
                  <span>{new Date(announcement.event_date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                </span>
              )}
              {announcement.event_time && (
                <span className="flex items-center space-x-1">
                  <FaClock size={12} />
                  <span>{announcement.event_time}</span>
                </span>
              )}
            </div>
          )}
          
          {/* Action Link */}
          {announcement.event_link && (
            <a
              href={announcement.event_link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-1 px-3 py-1.5 bg-[#FFD700]/20 text-[#FFD700] text-xs font-medium rounded-md hover:bg-[#FFD700]/30 transition-all"
            >
              <FaLink size={10} />
              <span>Register / Join</span>
            </a>
          )}
        </div>
      </div>
      
      {/* Posted time */}
      <div className="mt-2 pt-2 border-t border-[#2D5A8F]/50 flex items-center justify-between">
        <span className="text-gray-500 text-xs">
          Posted by {announcement.advisor_name}
        </span>
        <span className="text-gray-500 text-xs">
          {new Date(announcement.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })}
        </span>
      </div>
    </div>
  );
};

export default AnnouncementCard;
